import { createContext } from 'react'
import type { MockUser } from '@/utils/mockAuth'

export interface MockAuthContextValue {
  user: MockUser | null
  isAuthenticated: boolean
  login: (email: string) => void
  logout: () => void
}

export const MockAuthContext = createContext<MockAuthContextValue | null>(null)
